var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.996,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3037 -0.132812C65.3466 -0.132812 69.3897 -0.132812 73.4326 -0.132812C97.0692 2.73802 114.867 14.4275 126.826 34.9355C131.228 43.2336 133.909 52.0225 134.868 61.3027C134.868 65.3456 134.868 69.3888 134.868 73.4316C131.997 97.0682 120.308 114.866 99.7998 126.825C91.5018 131.227 82.7128 133.908 73.4326 134.867C69.3897 134.867 65.3466 134.867 61.3037 134.867C37.6671 131.996 19.8693 120.307 7.91016 99.7988C3.50823 91.5008 0.827561 82.7118 -0.131836 73.4316C-0.131836 69.3888 -0.131836 65.3456 -0.131836 61.3027C2.73889 37.6664 14.4283 19.8686 34.9365 7.90918C43.2345 3.50726 52.0235 0.826584 61.3037 -0.132812ZM100.327 37.8359C101.358 37.7734 102.325 37.9931 103.228 38.4951C104.941 40.209 106.655 41.9229 108.369 43.6367C108.777 44.3502 109.085 45.0975 109.292 45.8779C109.085 46.6584 108.777 47.4056 108.369 48.1191C92.3292 64.1591 76.289 80.1993 60.249 96.2393C58.8429 97.1181 57.4364 97.1181 56.0303 96.2393C45.8715 86.1686 35.808 76.0172 25.8398 65.7852C25.3836 64.7194 25.4715 63.6647 26.1035 62.6211C27.9933 60.7314 29.8827 58.8419 31.7725 56.9521C32.8066 56.3386 33.8613 56.2508 34.9365 56.6885C42.5756 64.0639 50.1343 71.5345 57.6123 79.1006C57.876 79.2765 58.1396 79.2765 58.4033 79.1006C71.8506 65.6533 85.2979 52.2061 98.7451 38.7588C99.2545 38.3741 99.7819 38.0667 100.327 37.8359Z",
    fill: "#00B45E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/done_icon.d09c87e0d6086d4c4c56534c6c8f3a92.svg";
export { ForwardRef as ReactComponent };